import Axios from "axios"

export const getGeoInfo = async () => {
    try {
        const response = await Axios.get(`https://ipapi.co/json/`);
        return response.data;
    } catch(error) {

    }
}